import axios from 'axios';

const getConfig = () => {
    const token = sessionStorage.getItem("tokenBearer");
    if (!token) {
        throw new Error("Token no disponible en sessionStorage");
    }
    return {
        headers: { 
            Authorization: `Bearer ${token}`,
            'X-OrigenId': '9',
            'X-ExodusDev': '0'
        }
    };
};

/**
 * Metodo para obtener una liga por id
 * @param {idLiga} getDataLigas 
 * @returns object con data de ligas
 */
export const getDataLigas = async (idLigas) => {
        try {
            const config = getConfig();
            const response = await axios.get(process.env.REACT_APP_LIGASPAGO+"/"+idLigas, config);

            return response;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.error("Error de autenticación: Token no válido o expirado");
                return false;
            }
        }
};

/**
 * Metodo para obtener información de la liga relacionada a un pedido
 * @param {idPedido} getDataLigas 
 * @returns object con data de ligas por pedido
 */
export const getDataLigasIdPedido = async (idPedido) => {
    const config = getConfig();
    return await axios.get(process.env.REACT_APP_LIGASPAGOUPDATE +"="+idPedido,config)
    .catch(function (error) {
        if (error.response) {
            return false;
        }
    });
}

/**
 * Metodo para obtener información acerca de un pedido
 * @param {idPedido} getDataPedido 
 * @returns object con data de pedido
 */
export const getDataPedido = async (idPedido) => {
    const config = getConfig();
    return await axios.get(process.env.REACT_APP_PASARELAPEDIDO + idPedido,config)
    .catch(function (error) {
        if (error.response) {
            return false;
        }
    });
}

/**
 * Metodo para obtener información acerca del detalle un pedido
 * @param {idPedido} getDataDetallePedido 
 * @returns object con data del detalle de un pedido
 */
export const getDataDetallePedido = async (idPedido) => {
    const config = getConfig();
    return await axios.get(process.env.REACT_APP_PASARELAPEDIDODETALLE + idPedido,config)
    .catch(function (error) {
        if (error.response) {
            return false;
        }
    });
}

/**
 * Metodo para obtener información acerca de un pedido por medio de origen
 * @param {idPedido, origen} getDataPedidoOrigen 
 * @returns object con data de pedido
 */
export const getDataPedidoOrigen = async (pedidoId,origen) => {
    const config = getConfig();
    return await axios.get(process.env.REACT_APP_PASARELAPEDIDOORIGEN+"?PedidoId="+pedidoId+"&OrigenId="+origen,config)
    .catch(function (error) {
        if (error.response) {
            return false;
        }
    });
}

/**
 * Metodo para actualizar el estatus de un pedido
 * @param {idLiga, estatus} actualizaLiga 
 * @returns boolean estatus de actualizacion
 */
export const actualizaLiga = async function (idLiga, estatus){
    const config = getConfig();
    return await axios.patch(process.env.REACT_APP_LIGASPAGO+"/"+idLiga, [{
      path: "EstatusId",
      op: "replace",
      value: estatus, 
    }],config)
    .catch(function (error) {
      if (error.response) {
        return false;
      }
    });
}

/**
 * Metodo para actualizar todo el registro de la liga
 * @param {obj} updateDataLiga 
 * @returns object con data de liga actualizada
 */
export const updateDataLiga = async (obj) => {
    const config = getConfig();
    return await axios.put(process.env.REACT_APP_LIGASPAGO, obj,config)
    .catch(function (error) {
        if (error.response) {
            return false;
        }
    });
}

/**
 * Metodo para validar si el precio, cantidades y productos del carrito han cambiado.
 * @returns estatus con el cambio
 */
export const validarPedido = async (body) => {
  try {
    const config = getConfig();
    const response = await axios.post(
      process.env.REACT_APP_VALIDAR_PEDIDO, // endpoint nuevo
      body,
      config
    );
    return response;
  } catch (error) {
    return error.response; // importante para capturar 400
  }
};


/**
 * Metodo para actualizar completamente el detalle del pedido con la información correcta del carrito.
 * @param {Object} body - detallePedido actualizado
 * @returns true or false
 */
export const actualizarPedidoDetalle = async (body) => {
  try {
    const config = getConfig();
    const response = await axios.put(
      process.env.REACT_APP_ACTUALIZAR_PEDIDO_DETALLE,
      body,
      config
    );
    
    return response;
  } catch (error) {
    return error.response;
  }
};

